module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.5f48ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_hero_600.png
// module id = n3FT
// module chunks = 0